/* istanbul ignore file */
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-history-card',
  templateUrl: './history-card.component.html',
  styleUrls: ['./history-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HistoryCardComponent {
}
